<template>
  <div class="pay-common">
    <div class="content-box">

      <div class="bread">
        <router-link class="bread-item" to="/">上上签</router-link>
        <div class="bread-arrow">&gt;</div>
        <router-link class="bread-item" to="/orders">订单管理</router-link>
        <div class="bread-arrow" v-if="+$route.query.typeid !== 1">&gt;</div>
        <router-link class="bread-item" :to="{name: 'orderDetail', params: { oid: $route.params.oid }}" v-if="+$route.query.typeid !== 1">订单详情</router-link>
        <div class="bread-arrow">&gt;</div>
        <router-link class="bread-item" :to="{name: 'payConfirm', params: { oid : $route.params.oid }, query: { typeid: $route.query.typeid, payPrice: $route.query.payPrice }}">支付订单</router-link>
      </div>

      <div class="main-box">
        <div class="type-title">{{typeList[+$route.query.typeid - 1]}}</div>
        <div class="pay-price">
          支付金额<span class="price-box"><span class="icon">￥</span>{{$route.query.payPrice}}</span>
        </div>
        <div class="pay-orderid">
          支付订单号<span class="orderid-box">{{this.$route.params.oid}}</span>
        </div>
        <div class="tips-box"><span v-if="!clicked">点击【去支付】在新打开的金棕榈收银台页面付款</span><span v-else>完成付款后，请点击【支付成功】</span></div>
        <!-- <div class="pay-ok-btn" @click="checkPayStatus('pay')"><span v-if="!clicked">去支付</span><span v-else>支付成功</span></div> -->
        <el-button type="primary" class="pay-ok-btn" :disabled="notPay" @click="checkPayStatus('pay')">{{clicked ? '支付成功' : '去支付'}}</el-button>
        <div class="pay-wrong-btn" @click="checkPayStatus('err')">支付遇到问题？</div>
      </div>


    </div>
  </div>
</template>

<script>
import Http from '@/libs/http';
import utils from '@/libs/utils';

export default {
  data() {
    return {
      typeList: ['订单支付', '修改赴馆时间', '顺丰取资料服务', '补缴费用'],
      pay_redirect_url: '',
      clicked: false,
      notPay: true,
    };
  },
  methods: {
    checkPayStatus(type) {
      if (!this.clicked && this.pay_redirect_url && type === 'pay') {
        this.clicked = true;
        return window.open(this.pay_redirect_url, '_blank');
      }

      Http.post('/order_pay_result_query', {
        user_order_id: +this.$route.params.oid,
        query_type: +this.$route.query.typeid,
      }).then((res) => {
        if (res.pay_status) {
          utils.msg.success('支付成功');
          this.$router.replace({ name: 'orderDetail', params: { oid: +this.$route.params.oid } });
        } else {
          const h = this.$createElement;
          this.$msgbox({
            title: '支付结果',
            message: h('div', null, [
              h('p', { style: 'line-height: 25px;' }, '订单未支付或正在支付中...'),
              h('p', { style: 'line-height: 25px;' }, '如果已支付订单，请等待支付结果，不要重复支付；'),
              h('p', { style: 'line-height: 25px;' }, '如果未支付订单，可“重新支付”订单。'),
            ]),
            showCancelButton: true,
            confirmButtonText: '重新支付',
            cancelButtonText: '取消',
          }).then(() => {
            if (this.pay_redirect_url) {
              window.open(this.pay_redirect_url, '_blank');
            }
          }).catch((e) => {
            if (e) console.log(e);
          });
        }
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    getUrl() {
      Http.post('/order_get_payurl', {
        user_order_id: +this.$route.params.oid,
      }).then((res) => {
        this.pay_redirect_url = res.pay_redirect_url;
        this.notPay = false;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    getPriceChangeUrl(typeID) {
      const applicants = typeID === 2 ? JSON.parse(this.$route.query.applicants) : undefined;
      Http.post('/palmyou_price_change', {
        user_order_id: +this.$route.params.oid,
        pay_item: typeID - 1,
        applicants,
      }).then((res) => {
        this.pay_redirect_url = res.pay_url;
        this.notPay = false;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
  },
  created() {
    const typeID = +this.$route.query.typeid;
    if (typeID) {

      // 订单支付
      if (typeID === 1) {
        this.getUrl();

      // 修改赴馆时间、顺丰取资料服务、补缴费用
      } else {
        this.getPriceChangeUrl(typeID);
      }
    }
  },
};
</script>

<style lang="less" scoped>
.pay-common {
  .content-box{
    width: 1000px;
    margin: 0 auto;
    .main-box{
      background-color: #ffffff;
      box-shadow: 0px 2px 6px 0px
        rgba(0, 0, 0, 0.05);
      border-radius: 4px;
      text-align: center;
      min-height: 440px;
      .type-title{
        font-size: 20px;
        font-weight: 600;
        color: #333333;
        padding: 30px 0 20px;
        background-color: rgba(94, 155, 225, 0.05);
      }
      .pay-price{
        font-size: 14px;
        color: #777777;
        background-color: rgba(94, 155, 225, 0.05);
        padding-bottom: 20px;
        .price-box{
          color: #fc7906;
          font-size: 20px;
          font-weight: 600;
          margin-left: 20px;
          .icon{
            font-size: 16px;
          }
        }
      }
      .pay-orderid{
        font-size: 14px;
        color: #777777;
        background-color: rgba(94, 155, 225, 0.05);
        padding-bottom: 30px;
        .orderid-box{
          margin-left: 20px;
          font-size: 14px;
          color: #333333;
        }
      }
      .tips-box{
        margin: 50px 0 30px;
        font-size: 16px;
        color: #333333;
      }
      .pay-ok-btn{
        width: 280px;
        height: 40px;
        // line-height: 40px;
        color: #ffffff;
        // background-color: #5e9be1;
        border-radius: 20px;
        font-size: 14px;
        margin: 0 auto 30px;
        // cursor: pointer;
      }
      .pay-wrong-btn{
        font-size: 14px;
        color: #5e9be1;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pay-confirm.vue